import {
  CATALOG_NICHE_DETAIL_SET_DATA,
  CATALOG_NICHE_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  niche: null,
  genres: null,
  booksets: [],
  books: null,
  audiobooks: null,
};

export default function nicheDetail(state = initialState, action) {
  switch (action.type) {
    case CATALOG_NICHE_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_NICHE_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
